export default "__VITE_ASSET__Dva7TyC1__"